import { Box } from "@mui/material";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CertificatesTable } from "../components/CertificatesTable";
import { ICertificate } from "../entities/certificates";
import { certificatesTableDataMapper } from "../lib/helper";
import { IState } from "../lib/store";


export const Certificates: React.FC = () => {
    const { year, grade, program } = useParams();
    const navigate = useNavigate();
    const certificates = useSelector((state: IState) => state.projects.certificates, shallowEqual);
    let currentCerts: ICertificate[] = [];
    if (certificates && year && grade && program) {
        currentCerts = certificates[year!][grade!][program!] as ICertificate[];
    }
    const rows = certificatesTableDataMapper(currentCerts || []);

    useEffect(() => {
        if (!certificates) {
            navigate('/');
        }
    }, []);
    
    return (
        <Box display="flex" flexDirection="column" gap={4} height="100%">
            <Box sx={{display: 'flex', gap: '2rem', width: '100%', height:'100%', overflow: 'scroll'}}>
                <Box flexGrow={1} ><CertificatesTable rows={rows} /></Box>
                {/* <MemberPannel members={project?.members!} projectID={project?.id!}/> */}
            </Box>
        </Box>
    )
}